import { useEffect, useRef } from 'react';


type IntervalCallback = () => void;
/**
 * Hook based version of setInterval
 * From https://overreacted.io/making-setinterval-declarative-with-react-hooks/
 * then modified to be strongly typed
 * @param callback 
 * @param delay 
 */
export function useInterval(callback: IntervalCallback, delay: number | null) {
    const savedCallback = useRef<IntervalCallback>(callback);
   
    // Remember the latest callback.
    useEffect(() => {
      savedCallback.current = callback;
    }, [callback]);
   
    // Set up the interval.
    useEffect(() => {
      function tick() {
        savedCallback.current();
      }
      if (delay !== null) {
        let id = setInterval(tick, delay);
        return () => clearInterval(id);
      }
    }, [delay]);
  }